import { curLang, curTerm, siteText, translate } from '@procumi/shared';
import { Fragment, type ReactNode } from 'react';

const TAG = /<(\/?)(b|i|em|strong|br)\s*\/?>/g;

/**
 * O frază întreagă cu cuvinte îngroșate înăuntru, tradusă dintr-o bucată:
 * `rich('Apasă <b>Trimite</b> când ești gata.')`. Așa traducerea poate muta
 * cuvântul îngroșat unde îi e locul în engleză. Merg doar <b>, <strong>, <i>, <em>
 * și <br/>; valorile ({0}, {1}…) se pun după, ca text, deci nu pot aduce etichete.
 */
export function rich(ro: string, ...args: ReactNode[]): ReactNode {
  const src = siteText(translate(ro), curTerm(), curLang());
  const out: ReactNode[] = [];
  const stack: { tag: string; kids: ReactNode[] }[] = [{ tag: '', kids: out }];
  let last = 0;
  let key = 0;
  const text = (s: string) => {
    for (const part of s.split(/(\{\d+\})/)) {
      if (!part) continue;
      const m = /^\{(\d+)\}$/.exec(part);
      stack[stack.length - 1]!.kids.push(m ? <Fragment key={key++}>{args[+m[1]!] ?? part}</Fragment> : part);
    }
  };
  for (const m of src.matchAll(TAG)) {
    text(src.slice(last, m.index));
    last = m.index! + m[0].length;
    const [, close, tag] = m;
    if (tag === 'br') stack[stack.length - 1]!.kids.push(<br key={key++} />);
    else if (!close) stack.push({ tag: tag!, kids: [] });
    else if (stack.length > 1) {
      const done = stack.pop()!;
      const El = done.tag as 'b';
      stack[stack.length - 1]!.kids.push(<El key={key++}>{done.kids}</El>);
    }
  }
  text(src.slice(last));
  return <>{out}</>;
}
